import { MESSAGES, type MessageKey } from './messages'
import type { TFunction } from './I18nContext'

/**
 * Libellé d'une valeur technique venue du serveur.
 *
 * Les codes arrivent en chaîne (`'SN'`, `'UNAUTHORISED_AGGREGATOR'`) : on les
 * cherche dans le catalogue sous `préfixe.CODE`. Une valeur inconnue — un code
 * que le serveur ajoute avant l'interface — s'affiche telle quelle plutôt que
 * de faire planter l'écran : un outil de conformité ne doit pas blanchir sur un
 * statut nouveau.
 */
export function enumLabel(
  t: TFunction,
  prefix: string,
  value: string | null | undefined,
  fallback = '—',
): string {
  if (!value) return fallback
  const key = `${prefix}.${value}` as MessageKey
  return key in MESSAGES ? t(key) : value
}

/** Vrai si le catalogue connaît ce code : utile pour choisir une variante. */
export function hasLabel(prefix: string, value: string | null | undefined): boolean {
  return !!value && `${prefix}.${value}` in MESSAGES
}
